'use strict';

var _ = require('lodash');

/**
 * Chart Legend Item Directive
 *
 * @constructor
 */
var ChartLegendItemDirective = function ChartLegendItemDirective() {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/chart-legend-item.html'),
    /**
     * @param {Object} scope
     * @param {Object} scope.item - Object containing config for legend item
     * @param {(number|string)} scope.items.id - unique ID of the object
     * @param {string} scope.items.fill - fill of the legend item (color|pattern url)
     * @param {string} scope.items.label - label text to be displayed
     * @param {ChartElementsConstants.LEGEND_ITEM.STYLE} [scope.items.style] - whether the item should be rendered as line or a circle. Defaults to rectangle
     * @param {boolean} [scope.items.dashed] - if style set to 'line', sets the line to dashed style
     * @param {string} [scope.items.stroke] - if style set to 'circle', sets the circle border color
     * @param {string} [scope.items.customDash] - custom set of dash styling
     * @param {string} [scope.items.strokeWidth] - custom width of the line
     * @param {string} [scope.items.tooltip] - HTML content of tooltip to be displayed
     * @param {boolean} [scope.items.selectable] - whether the item can be toggled on/off
     * @param {boolean} [scope.items.selected] - current selection state of the legend item
     * @param {boolean} [scope.items.labelItalic] - sets the label text to italic
     * @param {boolean} [scope.items.labelBold] - sets the label text to bold
     */
    scope: {
      item: '=',
      itemMaxLength: '=',
      toggleSelectionCallback: '='
    },
    link: function link(scope, element) {
      scope.item.selected = scope.item.selected === undefined ? true : scope.item.selected;
      scope.toggleTooltip = function () {
        if (scope.item.tooltip) {
          var currentOffset = element.offset();
          var parentOffset = element.offsetParent().offset();
          var targetOffset = {
            top: currentOffset.top - parentOffset.top,
            left: currentOffset.left - parentOffset.left
          };
          var data = {
            entityData: '',
            targetPosition: {
              offset: targetOffset,
              height: element.height(),
              width: element.width()
            },
            htmlContent: scope.item.tooltip
          };
          if (scope.tooltipShown) {
            scope.$emit('trigger-tooltip:hide');
          } else {
            scope.$emit('trigger-tooltip:show', data);
          }
          scope.tooltipShown = !scope.tooltipShown;
        }
      };
      scope.toggleSelection = function () {
        if (scope.item.selectable) {
          scope.item.selected = !scope.item.selected;
          var evtData = {
            id: scope.item.id,
            selected: scope.item.selected
          };
          scope.$emit('chart-legend:legend-item-toggle', evtData);
          if (scope.toggleSelectionCallback) {
            scope.toggleSelectionCallback(evtData);
          }
        }
      };
      scope.isDisabled = function () {
        return scope.item.selected === false;
      };
      scope.capitalizeItem = function (label) {
        if (label.length > 2) {
          return _.capitalize(label);
        } else {
          return '';
        }
      };

      // Legend item truncation
      scope.truncateItem = function (label, maxLength) {
        if (maxLength && label.length > maxLength) {
          return _.truncate(label, {
            'length': maxLength
          });
        } else {
          return label;
        }
      };
    }
  };
};
ChartLegendItemDirective.$inject = [];
module.exports = ChartLegendItemDirective;